var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Notification extends Component {
    constructor() {
        super('Notification', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.notification .alert').each((alert) => {
                if (alert.hasClass('alert-warning') || alert.hasClass('alert-danger') || alert.parents('.notification').hasClass('d-none'))
                    return;
                setTimeout(() => {
                    alert.addClass('d-none');
                }, 7500);
            });
            this.success();
        });
    }
    static show(message, type = 'success') {
        $('.notification').removeClass('d-none');
        const alert = $('.notification .alert');
        alert.removeClass('alert-success alert-danger alert-warning alert-info');
        alert.addClass('alert-' + type);
        alert.html(message);
    }
}
